import useMediaQueryHook from 'src/hooks/useMediaQuery.hook'
import { RootState } from 'src/store/store'
import Div from 'src/components/atomic/atom/Div'
import Svg from 'src/components/atomic/atom/Svg'
import React, { useEffect, useRef, useState } from 'react'
import { setImageDetailFlag, setSelectImage } from 'src/store/Reducer/page/locationPageSlice'
import { useAppSelector } from 'src/hooks/redux/useAppSelector'
import { useAppDispatch } from 'src/hooks/redux/useAppDispatch'
import Image from 'src/components/atomic/atom/Image'
import { useLockBodyScrollHook } from 'src/hooks/useLockBodyScroll.hook'
import { COLOR } from 'src/constants/colors'
import { useMediaQuery } from 'react-responsive'

const ImageDetail = () => {
  const { setMediaStyle, currentMedia } = useMediaQueryHook()
  const [deg, setDeg] = useState<number>(0)
  const { selectPin, selectImage } = useAppSelector((state: RootState) => state.LocationPage)
  const dispatch = useAppDispatch()
  const pcImageRef = useRef<HTMLImageElement>(null)
  const moImageRef = useRef<HTMLImageElement | null>(null)
  const pcDivRef = useRef<HTMLDivElement>(null)
  const [height, setHeight] = useState<string | undefined>()
  const { imageDetailFlag } = useAppSelector((state: RootState) => state.LocationPage)
  const wideImgMedia = useMediaQuery({ query: '(min-width: 1920px)' })

  const ImageDetailWrapStyle = {
    zIndex: 9999,
    width: '100%',
    height: `calc(var(--vh, 1vh) * 100)`,
    overflow: 'hidden',
    position: 'absolute',
    top: 0,
    left: 0,
    display: currentMedia === 'pc' && 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    background: setMediaStyle(COLOR.blackOpacity07, '#333333', '#333333'),
  }

  useLockBodyScrollHook(imageDetailFlag)

  useEffect(() => {
    setDeg(0)
  }, [selectImage])

  useEffect(() => {
    const degNum = Math.floor(deg / 90) % 2
    setHeight(window.innerHeight - 76 * 2 + 'px')
    if (moImageRef.current) {
      moImageRef.current.style.maxHeight =
        degNum === 0 ? window.innerHeight - 76 * 2 + 'px' : '100vw'
    }
  }, [deg, currentMedia])

  const PcImageComponent = () => {
    return (
      <>
        <Div $margin={'0'} $align_item={'center'} display={'flex'} ref={pcDivRef}>
          <Image
            ref={pcImageRef}
            display={'block'}
            $margin={'auto'}
            $ImgSrc={selectImage === 'F' ? selectPin?.FImage : selectPin?.BImage}
            style={{
              maxHeight: wideImgMedia ? '720px' : '520px',
              transform: `rotate(${deg}deg)`,
            }}
          />
        </Div>
        <Div
          display={'flex'}
          $justify_content={'center'}
          $padding={'16px 0 0'}
          $gap={'12px'}
          $margin={setMediaStyle('', '50px 0 0', '50px 0 0')}
        >
          <Svg
            name={'left_arrow'}
            opacity={selectImage === 'F' ? '0.3' : ''}
            onClick={() => dispatch(setSelectImage('F'))}
          />
          <Svg
            name={'right_arrow'}
            opacity={selectImage === 'B' ? '0.3' : ''}
            onClick={() => dispatch(setSelectImage('B'))}
          />
          <Svg
            name={'image_reload_icon'}
            onClick={() => {
              setDeg((d) => d + 90)
              if (pcImageRef.current && pcDivRef.current) {
                const h = pcImageRef.current.getBoundingClientRect().height
                pcDivRef.current.style.height = `${h}px`
              }
            }}
          />
        </Div>
      </>
    )
  }

  const MoImageComponent = () => {
    return (
      <>
        <Div
          $max_height={height}
          style={{
            height: '100%',
            width: `100%`,
            position: 'absolute',
            left: '50%',
            top: '50%',
            transform: 'translate(-50%,-50%)',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
          }}
        >
          <Image
            ref={moImageRef}
            $ImgSrc={selectImage === 'F' ? selectPin?.FImage : selectPin?.BImage}
            display={'block'}
            style={{
              width: '100%',
              height: '100%',
              display: 'block',
              transform: `rotate(${deg}deg)`,
            }}
          />
        </Div>
        <Div
          display={'flex'}
          $justify_content={'center'}
          $position={'absolute'}
          width={'100%'}
          $gap={'12px'}
          style={{
            position: 'absolute',
            left: '50%',
            bottom: '16px',
            transform: 'translate(-50%,0%)',
          }}
        >
          <Svg
            name={'left_arrow'}
            width={'44px'}
            height={'44px'}
            opacity={selectImage === 'F' ? '0.3' : ''}
            onClick={() => dispatch(setSelectImage('F'))}
          />
          <Svg
            name={'right_arrow'}
            width={'44px'}
            height={'44px'}
            opacity={selectImage === 'B' ? '0.3' : ''}
            onClick={() => dispatch(setSelectImage('B'))}
          />
          <Svg
            name={'image_reload_icon'}
            width={'44px'}
            height={'44px'}
            onClick={() => setDeg((d) => d + 90)}
          />
        </Div>
      </>
    )
  }

  return (
    <Div style={ImageDetailWrapStyle}>
      <Div display={'flex'} $align_item={'center'} $flex_direction={'column'}>
        <Svg
          name={'imagedetail_xIcon'}
          width={setMediaStyle('56px', '44px', '44px')}
          height={setMediaStyle('56px', '44px', '44px')}
          onClick={() => dispatch(setImageDetailFlag(false))}
          $margin={'0 0 16px'}
          style={{
            position: currentMedia !== 'pc' && 'absolute',
            top: currentMedia !== 'pc' && '16px',
            left: currentMedia !== 'pc' && '16px',
          }}
        />
        {currentMedia === 'pc' ? <PcImageComponent /> : <MoImageComponent />}
      </Div>
    </Div>
  )
}
export default ImageDetail
